import { Box, Card, Typography, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { api } from "../../http"; 
import { AuthUserType } from "../../types/authUser.types";

export const AuthUserPage: React.FC = () => {
  const [users, setUsers] = useState<AuthUserType.Model[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<AuthUserType.Model[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  useEffect(() => {
    const fetchAuthUsers = async () => {
      setLoading(true);
      try {
        const response = await api.post(`/auth/list-auth-users`);
        const { result, isValid } = response.data;
        if (isValid) {
          setUsers(result);
          setFilteredUsers(result);
        }
      } catch (error) {
        console.error("Error fetching auth users:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAuthUsers();
  }, []);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredUsers(users);
    } else {
      const lowerCaseSearch = searchTerm.toLowerCase();
      setFilteredUsers(
        users.filter((user) =>
          user.phoneNumber.toLowerCase().includes(lowerCaseSearch)
        )
      );
    }
  }, [searchTerm, users]);

  return (
    <Box 
        p={4}
        width='50vw'
    >
      <Typography variant="h4" mb={4}>
        AUTH CODES
      </Typography>

      <TextField
        label="Search by Phone Number"
        variant="outlined"
        fullWidth
        sx={{ mb: 4 }}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        filteredUsers.map((user) => (
          <Card
            key={user._id}
            sx={{
              mb: 2,
              p: 2,
              border: "1px solid #ccc",
              borderRadius: 2,
              backgroundColor: "#f9f9f9",
            }}
          >
            <Typography variant="body1">
              <strong>Phone Number:</strong> {user.phoneNumber}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Last Code Sent:</strong> {user.lastCodeSent}
            </Typography>
          </Card>
        ))
      )}
    </Box>
  );
};
